import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  width: 100%;
  .drag-drop-zone {
    min-height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`

export const ExampleLinksWrapper = styled.div`
  display: flex;
  gap: 0.7rem;
  margin-left: auto;
`

export const UploadContent = styled.div`
  text-align: center;
  width: 100%;
`

export const RulesSection = styled.div`
  ${({ theme }) => css`
    margin-top: 1rem;
    text-align: left;

    .rules-title {
      font-size: ${theme.font.sizes.small};
      margin-bottom: 0.75rem;
    }

    .rules-list {
      margin: 0;
      padding-left: 1.5rem;
      font-size: ${theme.font.sizes.xsmall};

      li {
        margin-bottom: 0.5rem;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  `}
`
